import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "rec-translation-indicator rec-translation-indicator--pending"
};
const _hoisted_2 = { key: 0 };
import SvgIcon from "@/common/components/SvgIcon.vue";
import { useContext } from "@/store/context";
import { storeToRefs } from "pinia";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TranslationIndicator',
    props: {
        translationPending: { type: Boolean },
        sourceLocale: {}
    },
    setup(__props) {
        // Components
        const contextStore = useContext();
        const { isAdmin } = storeToRefs(contextStore);
        return (_ctx, _cache) => {
            return (_ctx.translationPending)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(SvgIcon, { icon: "icon-dashed-circle" }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("Translation Pending")), 1)
                ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["rec-translation-indicator", { 'rec-translation-indicator--admin': _unref(isAdmin) }])
                }, [
                    _createVNode(SvgIcon, { icon: "icon-locale" }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("View Original")) + " ", 1),
                    (_ctx.sourceLocale)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(" + _toDisplayString(_ctx.sourceLocale) + ")", 1))
                        : _createCommentVNode("", true)
                ], 2));
        };
    }
});
